import { render } from "./eclipse.vue?vue&type=template&id=9561c658&scoped=true"
import script from "./eclipse.vue?vue&type=script&lang=ts"
export * from "./eclipse.vue?vue&type=script&lang=ts"

import "./eclipse.vue?vue&type=style&index=0&id=9561c658&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9561c658"

export default script